// client\src\pages\visitor\parceirosPage.jsx

import React, { useEffect, useState, } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../api/axios';
import { isAuthenticated } from '../../index';
import styles from './parceirosPage.module.css';
import GraficoParceiros from '../../components/Graficos/GraficoParceiro';
import { FaLink, FaWhatsapp, FaGlobeAmericas, FaUsers, FaRegCheckCircle, FaRegUser, FaRegCopy, FaChartBar } from 'react-icons/fa';


export default function ParceirosPage() {

    console.log('Renderizando ParceirosPage...');
    const { authenticated, userPermission } = isAuthenticated();
    const isAdmin = authenticated && Number(userPermission) > 0;
    const { usuarioParceiro } = useParams(); // Obtém o clienteId da URL
    console.log('usuarioParceiro:', usuarioParceiro); // Verifica se o clienteId está sendo obtido corretamente
    // const [parceiroId, setParceiroId] = useState(null);
    const [parceiroNaoEncontrado, setParceiroNaoEncontrado] = useState(false);



    const [dadosParceiro, setDadosParceiro] = useState(null);
    const [vendasParceiro, setVendasParceiro] = useState([]);

    useEffect(() => {
        async function fetchParceiroPorUsuario() {
            try {
                const response = await api.get(`/parceiroPorUsuario/${usuarioParceiro}`);
                if (response.data && response.data.id) {
                    // setParceiroId(response.data.id);
                    // console.log('ID do parceiro:', response.data.id); // Verifica se o ID do parceiro está sendo obtido corretamente
                    fetchDadosParceiro(response.data.id);
                    fetchVendasParceiro(response.data.id);
                } else {
                    setParceiroNaoEncontrado(true);
                }
            } catch (error) {
                console.error('Erro ao buscar parceiro pelo usuarioParceiro:', error);
                setParceiroNaoEncontrado(true); // Se deu erro (tipo 404), considera como não encontrado
            }
        }


        async function fetchDadosParceiro(id) {
            console.log('Buscando dados do parceiro com ID:', id); // Verifica se o ID do parceiro está sendo passado corretamente
            try {
                const response = await api.get(`/clientesPorParceiro/${id}`);
                console.log('Dados do parceiro:', response.data); // Verifica se os dados do parceiro estão sendo obtidos corretamente
                setDadosParceiro(response.data);
            } catch (error) {
                console.error('Erro ao buscar dados do parceiro:', error);
            }
        }

        async function fetchVendasParceiro(id) {
            try {
                const response = await api.get(`/historicoVendasPorParceiro/${id}`);
                console.log('Vendas do parceiro:', response.data);
                setVendasParceiro(response.data);
            } catch (error) {
                console.error('Erro ao buscar vendas do parceiro:', error);
            }
        }

        fetchParceiroPorUsuario();
    }, [usuarioParceiro]);




    // const comissaoTotal = vendasParceiro.reduce((total, item) => total + item.valor * 0.15, 0).toFixed(2);

    if (parceiroNaoEncontrado) {
        return (
            <main className={styles.page}>
                <div className={styles.emptyState}>
                    <span className={styles.eyebrow}>Portal do parceiro</span>
                    <img src="/memoji/Ainglobal.gif" alt="" className={styles.emptyImage} />
                    <h1>Parceiro não encontrado!</h1>
                    <p>Confira o link recebido ou fale com nossa equipe para começar sua parceria.</p>
                    <div className={styles.emptyActions}>
                        <button className={styles.primaryButton} onClick={() => {
                            window.open('https://wa.me/5561998819381?text=Ol%C3%A1%2C+gostaria+de+ajuda+para+me+tornar+parceiro!', '_blank');
                        }}>Quero me tornar um parceiro</button>
                        <button className={styles.secondaryButton} onClick={() => {
                            window.open('https://wa.me/5561998819381?text=Ol%C3%A1%2C+gostaria+de+ajuda+para+me+tornar+parceiro!', '_blank');
                        }}>Entrar em contato</button>
                    </div>
                </div>
            </main>
        );
    }

    return (
        <main className={styles.page}>
            <div className={styles.container}>
                <header className={styles.header}>
                    <div>
                        <span className={styles.eyebrow}>Portal do parceiro</span>
                        <h1>Bem-Vindo(a) {dadosParceiro?.nomeParceiro || 'Carregando...'}</h1>
                        <p>Acompanhe suas indicações e compartilhe novas possibilidades.</p>
                    </div>
                    <div className={styles.partnerBadge}>
                        <FaRegUser aria-hidden="true" />
                        <span>{dadosParceiro?.usuarioParceiro || usuarioParceiro}</span>
                    </div>
                </header>

                <section aria-labelledby="resumo-title">
                    <div className={styles.sectionHeading}>
                        <h2 id="resumo-title">Sua parceria em números</h2>
                        <span>Resumo geral</span>
                    </div>
                    <div className={styles.statsGrid}>
                        <article className={styles.statCard}>
                            <span className={`${styles.statIcon} ${styles.blue}`}><FaGlobeAmericas aria-hidden="true" /></span>
                            <h3>Total de acessos ao site com seu link:</h3>
                            <p className={styles.statValue}>{dadosParceiro?.contaSite ?? '-'}</p>
                            <span className={styles.statNote}>Visitas pelo seu link do site</span>
                        </article>
                        <article className={styles.statCard}>
                            <span className={`${styles.statIcon} ${styles.green}`}><FaWhatsapp aria-hidden="true" /></span>
                            <h3>Total de acessos ao WhatsApp com seu link: <b>(NOVO)</b></h3>
                            <p className={styles.statValue}>{dadosParceiro?.contaWhatsapp ?? '-'}</p>
                            <span className={styles.statNote}>Acessos pelo seu link de contato</span>
                        </article>
                        <article className={styles.statCard}>
                            <span className={`${styles.statIcon} ${styles.purple}`}><FaUsers aria-hidden="true" /></span>
                            <h3>Clientes cadastrados:</h3>
                            <p className={styles.statValue}>{dadosParceiro?.total_clientes ?? '-'}</p>
                            <span className={styles.statNote}>São pessoas que chegaram por você e iniciaram o processo de preenchimento dos formulários.</span>
                        </article>
                        <article className={styles.statCard}>
                            <span className={`${styles.statIcon} ${styles.amber}`}><FaRegCheckCircle aria-hidden="true" /></span>
                            <h3>Serviços Fechados:</h3>
                            <p className={styles.statValue}>{vendasParceiro.length}</p>
                            <span className={styles.statNote}>São pessoas que chegaram por você e de fato pagaram pelo serviço.</span>
                        </article>
                    </div>
                </section>

                <section className={styles.shareSection} aria-labelledby="share-title">
                    <div className={styles.shareIntro}>
                        <span className={styles.eyebrow}>Compartilhe e ganhe</span>
                        <h2 id="share-title">Uma indicação.<br /> Novas possibilidades.</h2>
                        <p>Escolha um canal, copie seu link e compartilhe com quem está planejando a próxima viagem.</p>
                        <span className={styles.shareHint}><FaLink aria-hidden="true" /> Seus links de comissão</span>
                    </div>
                    <div className={styles.linkGrid}>
                        <article className={styles.linkCard}>
                            <span className={`${styles.statIcon} ${styles.blue}`}><FaGlobeAmericas aria-hidden="true" /></span>
                            <h3>Indique pelo site</h3>
                            <p>Apresente nossos serviços com o seu link de indicação.</p>
                            <div className={styles.linkPreview}>agilizavisto.com <span>Parceiro: {dadosParceiro?.usuarioParceiro || usuarioParceiro}</span></div>
                            <button className={styles.primaryButton} onClick={() => {
                                const linkSite = `https://agilizavisto.com/?parceiro=${dadosParceiro?.usuarioParceiro}`;
                                navigator.clipboard.writeText(linkSite);
                                alert('🔗 Link para o site copiado!');
                            }}>
                                <FaRegCopy aria-hidden="true" /> Copiar Link para o Site
                            </button>
                        </article>
                        <article className={styles.linkCard}>
                            <span className={`${styles.statIcon} ${styles.green}`}><FaWhatsapp aria-hidden="true" /></span>
                            <h3>Conecte pelo WhatsApp</h3>
                            <p>Facilite o contato com a equipe e acompanhe os acessos.</p>
                            <div className={styles.linkPreview}>+55 (61) 99881-9381 <span>Parceiro: {dadosParceiro?.usuarioParceiro || usuarioParceiro}</span></div>
                            <button className={`${styles.primaryButton} ${styles.whatsappButton}`}
                                disabled={!dadosParceiro?.usuarioParceiro}
                                onClick={async () => {
                                    const linkWhats = new URL(api.getUri({ url: '/api/parceiros/whatsapp' }), window.location.origin);
                                    linkWhats.searchParams.set('phone', '5561998819381');
                                    linkWhats.searchParams.set('parceiro', dadosParceiro.usuarioParceiro);
                                    try {
                                        await navigator.clipboard.writeText(linkWhats.toString());
                                        alert('Link para WhatsApp copiado!');
                                    } catch (error) {
                                        alert('Não foi possível copiar o link. Tente novamente.');
                                    }
                                }}>
                                <FaRegCopy aria-hidden="true" /> Copiar Link para WhatsApp
                            </button>
                        </article>
                    </div>
                </section>

                <section className={styles.historySection} aria-labelledby="history-title">
                    <div className={styles.historyHeading}>
                        <span className={`${styles.statIcon} ${styles.blue}`}><FaChartBar aria-hidden="true" /></span>
                        <div>
                            <h2 id="history-title">Histórico de indicações</h2>
                            <p>Veja a evolução das suas indicações ao longo do tempo.</p>
                        </div>
                    </div>
                    <GraficoParceiros rawData={vendasParceiro} intervalo={60} isAdmin={isAdmin} />
                </section>
                <p className={styles.footerNote}>Cada indicação é o começo de uma nova viagem.</p>
            </div>
        </main>
    );
}
